export const HOME = "/";
export const ABOUT = "/about";
export const PROJECTS = "/projects";
export const SKILLS = "/skills";
export const CONTACT = "/contact";
